export default "__VITE_ASSET__m2EOiAj4__"